export const ACCORDION_OVERWRITES = {
  classNames: {
    root: {
      base: '',
      variants: {
        filter: 'bg-transparent',
        card: 'rounded-lg  bg-white flex-1 h-fit p-0',
      },
    },

    item: {
      base: '',
      variants: {
        filter: 'border-b-0',
        card: 'p-0',
      },
    },

    content: {
      base: 'overflow-hidden text-sm',
      variants: {
        filter: 'pb-4 px-2',
        card: 'px-4 pb-4 pt-2 bg-background p-0',
      },
    },
  },
};
